import { render, staticRenderFns } from "./SunEditor.vue?vue&type=template&id=2200c3b7&scoped=true"
import script from "./SunEditor.vue?vue&type=script&lang=js"
export * from "./SunEditor.vue?vue&type=script&lang=js"
import style0 from "./SunEditor.vue?vue&type=style&index=0&id=2200c3b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2200c3b7",
  null
  
)

export default component.exports